import axios from 'axios';
import config from '../../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../../core/modules/common/tools/URLTools';

const apiFetchPredesComplianceGapsInDespatchNumbers = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getPredesComplianceGapsInDespatchNumbers',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchPredesComplianceGapsInDespatchNumbers;
